import React, { useReducer } from 'react'
import { t } from 'i18next';
import { getOpenningsListService, changeConfigToOpenningService } from '../../services/Settings';
import OpenningManagementContext from './OpenningManagementContext';
import OpenningManagementReducer from './OpenningManagementReducer';
import { logout } from '../../services/login';
import { getTenantInfoByKey } from '../../helpers/helpers';

const OpenningManagementState = ({ children }) => {
    const buildingName = getTenantInfoByKey('building_name');
    const openingName = getTenantInfoByKey('opening_name');

    const initialState = {
        openningsToConfig: [],
        isFetching: true,
        error: {
            ok: false,
            text: ''
        },
    }

    const [state, dispatch] = useReducer(OpenningManagementReducer, initialState);

    const getOpennigsManagement = async (query) => {
        try {
            const items = await getOpenningsListService(query);

            if (items.ok) {
                dispatch({
                    type: 'GET_OPENNINGS_TO_CONFIG',
                    payload: {
                        openningsToConfig: items.data.response,
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'GET_OPENNINGS_TO_CONFIG',
                    payload: {
                        openningsToConfig: state.openningsToConfig,
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'GET_OPENNINGS_TO_CONFIG',
                payload: {
                    resources: state.openningsToConfig,
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }
    const changeConfigToOpenning = async (setting) => {
        try {
            const response = await changeConfigToOpenningService(setting);

            if (response.ok) {
                const { opening_code, is_access } = setting;
                changeOppositeValue(opening_code, is_access);

                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        /*                         openningsToConfig: state.openningsToConfig, */
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {
                switch (response.data.error_code) {
                    case 'OPENING_ASSIGNED_PEOPLE_TO_VISIT':
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: t('OPENING_WITH_PERSON_ASIGNED_ERROR')
                                }
                            }
                        })
                        break;
                    case 'RESOURCES_IN_OPENING':
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: t('RESOURCES_IN_OPENING_ERROR')
                                }
                            }
                        })
                        break;
                    case 'BUILDINGS_WITHOUT_OPENING':
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: `${t('THERE_ARE')} ${buildingName} ${t('WITHOUT')} ${openingName}`
                                }
                            }
                        })
                        break;
                    case 'BUILDINGS_IN_OPENING':
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: `${t('BUILDINGS_IN_OPENING')} ${buildingName}`
                                }
                            }
                        })
                        break;
                    case 'RESOURCES_IN_WITHOUT_OPENING':
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: `${t('NOT_ENABLE_OPENING_WITHOUT_OPNING')} ${openingName}  ${t('ASSIGNED2')}`
                                }
                            }
                        })
                        break;
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: t('TOKEN_ERROR')
                                }
                            }
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'CHANGE_SETTING',
                            payload: {
                                openningsToConfig: state.openningsToConfig,
                                error: {
                                    ok: true,
                                    text: t('SERVER_ERROR')
                                }
                            }
                        })
                        break;
                }
                return response;
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CHANGE_SETTING',
                payload: {
                    openningsToConfig: state.openningsToConfig,
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
            return {
                ok: false
            }
        }
    }
    const cleanOpenningManagementState = () => {
        dispatch({
            type: 'CLEAN_STATE',
        });
    }
    const changeOppositeValue = (key, value) => {
        state.openningsToConfig.forEach(el => {
            if (el.code === key) {
                el.is_access = value;
            }
        });

        dispatch({
            type: 'CHANGE_SETTING_LOCAL',
            payload: state.openningsToConfig
        });
    }

    return (
        <OpenningManagementContext.Provider
            value={{
                openningManagementState: state,
                getOpennigsManagement,
                changeConfigToOpenning,
                cleanOpenningManagementState
            }}
        >
            {children}
        </OpenningManagementContext.Provider>
    )
}

export default OpenningManagementState